(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const collectionFilters = document.querySelector('.gs-filters');

  if (collectionFilters && window.matchMedia('(max-width: 749px)').matches) {
    collectionFilters.removeAttribute('open');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-home"] && !Shopify.designMode) return;
  try {
    
  const revealItems = document.querySelectorAll('.gs-reveal');

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-kategorie"]) return;
  try {
    
  /* Filtern, Sortieren und Blaettern ohne Neuladen der Seite.

     Ohne dieses Skript bleibt alles bedienbar: die Filter sind echte
     GET-Formulare mit Knopf, das Auswahlfeld der Sortierung traegt ein
     Inline-onchange. Beides wird hier abgeschaltet und uebernommen, sonst
     liefe der Klick doppelt.

     Nachgeladen wird ueber Shopifys Section Rendering API, also nur diese
     Sektion statt der ganzen Seite (`?section_id=`). Getauscht wird der
     INHALT von .gs-kat, das Element selbst bleibt stehen: daran haengt der
     Alpine-Zustand (Raster/Liste, offene Schublade), der ueberlebt damit
     jeden Filterklick. Alpine erkennt neu eingefuegte Knoten von selbst.

     Faellt etwas aus (kein fetch, Netzfehler, unerwartete Antwort), geht es
     auf dem normalen Weg weiter: volle Navigation zur Ziel-URL. */
  (function () {
    var wurzel = document.querySelector('.gs-kat');
    if (!wurzel || !window.fetch || !window.DOMParser || !window.AbortController) return;
    var sektion = wurzel.getAttribute('data-sektion');
    if (!sektion) return;

    var lauf = 0;
    var abbruch = null;

    /* Der Inline-Rueckfall muss weg, sobald wir uebernehmen, und nach jedem
       Tausch erneut: die nachgeladene Sektion bringt ihn wieder mit. */
    function entschaerfen() {
      var alt = wurzel.querySelectorAll('[onchange]');
      for (var i = 0; i < alt.length; i++) {
        if ((alt[i].getAttribute('onchange') || '').indexOf('form.submit') !== -1) {
          alt[i].removeAttribute('onchange');
        }
      }
    }

    function adresse(formular) {
      var p = new URLSearchParams(new FormData(formular));
      /* Leere Preisfelder erzeugen sonst `...price.gte=&...price.lte=` in der
         Adresszeile, bei jedem Klick aufs Neue. */
      var leer = [];
      p.forEach(function (wert, schluessel) { if (wert === '') leer.push(schluessel); });
      for (var i = 0; i < leer.length; i++) p.delete(leer[i]);
      var q = p.toString();
      return location.pathname + (q ? '?' + q : '');
    }

    function laden(url, schieben) {
      var meins = ++lauf;
      if (abbruch) abbruch.abort();
      abbruch = new AbortController();
      wurzel.setAttribute('data-laedt', '');

      var trenner = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + trenner + 'section_id=' + encodeURIComponent(sektion), {
        signal: abbruch.signal
      })
        .then(function (a) {
          if (!a.ok) throw new Error('HTTP ' + a.status);
          return a.text();
        })
        .then(function (text) {
          if (meins !== lauf) return;
          var neu = new DOMParser().parseFromString(text, 'text/html').querySelector('.gs-kat');
          if (!neu) throw new Error('Antwort ohne .gs-kat');
          wurzel.innerHTML = neu.innerHTML;
          entschaerfen();
          wurzel.removeAttribute('data-laedt');
          if (schieben) history.pushState({ gsKat: 1 }, '', url);
        })
        .catch(function (fehler) {
          if (fehler && fehler.name === 'AbortError') return;
          window.location.href = url;
        });
    }

    entschaerfen();

    document.addEventListener('change', function (e) {
      var f = e.target.form;
      if (f && f.hasAttribute('data-filterform')) laden(adresse(f), true);
    });

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.hasAttribute && f.hasAttribute('data-filterform')) {
        e.preventDefault();
        laden(adresse(f), true);
      }
    });

    /* Gesetzte-Filter-Chips, "Alle zuruecksetzen" und das Blaettern sind
       Links. Abgefangen wird nur, was auf DIESELBE Seite zeigt; Produkte und
       Unterkategorien liegen auf einem anderen Pfad und gehen normal. */
    document.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('.gs-kat a[href]') : null;
      if (!a || a.target) return;
      var u;
      try { u = new URL(a.href, location.href); } catch (x) { return; }
      if (u.origin !== location.origin || u.pathname !== location.pathname) return;
      e.preventDefault();
      laden(u.pathname + u.search, true);
      if (u.search.indexOf('page=') !== -1) {
        wurzel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    window.addEventListener('popstate', function () {
      laden(location.pathname + location.search, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menuDetails = document.querySelectorAll('.gs-menu__item > details');
  const desktopMenu = window.matchMedia('(min-width: 990px)');
  const closeTimers = new WeakMap();

  menuDetails.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;

      menuDetails.forEach((otherMenu) => {
        if (otherMenu !== menu) otherMenu.removeAttribute('open');
      });
    });

    menu.addEventListener('pointerenter', () => {
      if (!desktopMenu.matches) return;
      window.clearTimeout(closeTimers.get(menu));
      menu.setAttribute('open', '');
    });

    menu.addEventListener('pointerleave', () => {
      if (!desktopMenu.matches) return;
      const timer = window.setTimeout(() => menu.removeAttribute('open'), 500);
      closeTimers.set(menu, timer);
    });

    menu.addEventListener('focusin', () => {
      if (desktopMenu.matches) menu.setAttribute('open', '');
    });

    menu.addEventListener('focusout', (event) => {
      if (desktopMenu.matches && !menu.contains(event.relatedTarget)) menu.removeAttribute('open');
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.gs-menu__item')) return;
    menuDetails.forEach((menu) => menu.removeAttribute('open'));
  });

  /* Kopf am Handy beim Runterscrollen wegschieben (2026-09-03).

     Warum ueberhaupt Javascript: der klebende Kopf belegte 191px von 844,
     also fast ein Viertel des Bildschirms, dauerhaft. Rein mit CSS laesst
     sich "nur beim Hochwischen zeigen" nicht ausdruecken.

     Zwei Bedingungen, unter denen die Klasse NIE gesetzt sein darf:
     - ueber 767px, dort macht `gs-katnav` die Navigation
     - bei offenem Menue, sonst wird der Kopf durch den transform zum
       Bezugsrahmen seines eigenen `position: fixed`-Vorhangs */
  {
    const kopf = document.querySelector('.gs-header');
    const sektion = kopf && kopf.closest('.shopify-section-group-header-group');
    const menue = document.querySelector('.gs-header__navigation');
    const handy = window.matchMedia('(max-width: 767px)');

    if (sektion) {
      let letzteHoehe = window.scrollY;

      const zeigen = () => sektion.classList.remove('gs-kopf--weg');

      window.addEventListener(
        'scroll',
        () => {
          const y = window.scrollY;
          if (!handy.matches || (menue && menue.open)) {
            zeigen();
            letzteHoehe = y;
            return;
          }
          // Die 200px Karenz halten den Kopf oben auf der Seite ruhig, sonst
          // zuckt er schon beim ersten Wischen.
          if (y > letzteHoehe && y > 200) sektion.classList.add('gs-kopf--weg');
          else if (y < letzteHoehe) zeigen();
          letzteHoehe = y;
        },
        { passive: true }
      );

      if (menue) menue.addEventListener('toggle', zeigen);
      handy.addEventListener('change', zeigen);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
